export const translations = {
  sl: {
    nav: { scrollHint: 'Odkrijte več' },

    hero: {
      badge:    'Projekt INFORMERS',
      title1:   'Strateška prevlada',
      title2:   'na terenu.',
      subtitle: 'Vaš operativni steber za vizijo \u201cSmoke-Free Future\u201d. Brezhibna izvedba programa INFORMERS s poudarkom na skladnosti, etiki in merljivih rezultatih.',
    },

    legacy: {
      label:      'The Powerhouse',
      headline:   'Operativna odličnost skozi moč odnosov.',
      body:       'V Wibe Solutions verjamemo, da vrhunskih rezultatov ne prinašajo le procesi, temveč pristen \u201evibe\u201c \u2013 kultura zaupanja in energije, ki transformira terensko aktivacijo v izjemno uporabniško izkušnjo.',
      feat1Title: 'Dolgoletne izkušnje',
      feat1Body:  'Večletne izkušnje v FMCG sektorju in kompleksnih promocijah. Naša zgodovina govori za nas.',
      feat2Title: 'Baza brez konkurence',
      feat2Body:  'Dostop do mreže 2.800+ preverjenih komunikatorjev z izkušnjami v HoReCa okolju. Ne iščemo novih ljudi; aktiviramo talente, ki so z nami rasli.',
      feat3Title: 'Nacionalna pokritost',
      feat3Body:  'Celotna Slovenija pokrita. Od Kopra do Murske Sobote, od Nove Gorice do Novega mesta.',
      kpi1:  'HoReCa lokacij',
      kpi2:  'Preverjenih talentov',
      kpi3:  'Nadpovprečna stabilnost',
      kpi4:  'Starostna skupina',
      regionWest: 'CENTER & ZAHOD',
      regionEast: 'VZHOD',
    },

    team: {
      label:    'Ekipa na projektu',
      headline: 'Ljudje za',
      headlineAccent: 'rezultatom.',
      sub:      'Izkušena ekipa, ki stoji za vsakim uspehom na terenu.',
      members: [
        {
          name: 'Žiga Goltes', title: 'CEO',
          bio: 'Z več kot 15-letnimi izkušnjami v agencijskem svetu in vodenju kompleksnih BTL projektov ne gradi le procesov, temveč odnose. Kot soustvarjalec inovacij v Agenciji 101 je tlakoval pot modernim pristopom k promociji. Danes v okviru Wibe Solutions združuje moč novih tehnologij s pristno človeško komunikacijo.',
        },
        {
          name: 'Andrej Hrastar', title: 'Vodja projekta',
          bio: 'Strateški vodja z več kot 20-letnimi izkušnjami v avtomobilski industriji in prodajnem managementu. Svojo pot je gradil na vodenju ključnih projektov za Porsche in VW, kjer se je specializiral za vzpostavitev e-mobilnosti in inovativnih go-to-market strategij.',
        },
        {
          name: 'Karin Kočar', title: 'Recruitment & Back Office',
          bio: 'Z več kot 15-letno kilometrino v upravljanju hostesnih in promocijskih storitev je ena vodilnih strokovnjakinj za terensko kadrovanje v Sloveniji. Njena vloga pri projektu INFORMERS je ključna: zagotavljanje vrhunske selekcije informatorjev (21+).',
        },
        {
          name: 'Alen Radi', title: 'Operativa',
          bio: 'V svetu terenskih aktivacij je sinonim za operativno ostrino in zanesljivost. Kot desna roka vodstva prevzema odgovornost za tehnično in logistično stabilnost projektov, pri čemer s svojo prodornostjo izstopa kot eden najperspektivnejših posameznikov svoje generacije.',
        },
      ],
      refsLabel: 'Reference',
      refs: [
        'Agencija 101 d.o.o.',
        'Pivoarna Laško Union d.o.o.',
        'Coca Cola HBC Slovenija d.o.o.',
        'Zavarovalnica Vita, d.d.',
        'EUROSPIN EKO, d.o.o.',
        'Komisija za preprečevanje korupcije',
        'DEKRA ZAPOSLITEV d.o.o. (JTI)',
      ],
    },

    wibeFactor: {
      label:          'The Wibe Factor',
      headline:       'Zakaj energija',
      headlineAccent: 'prinaša številke.',
      quote:          'Wibe ni le naše ime, je naš način dela. Dobri odnosi znotraj ekipe so tisti nevidni motor, ki poganja vidne rezultate na terenu.',
      quoteAuthor:    'Žiga Goltes, direktor',
      cards: [
        { title: 'Pristen stik, ne le statistika', text: 'Informator z dobro energijo ne le doseže 20 kontaktov na izmeno, ampak pusti pozitiven vtis o blagovni znamki IQOS/RRP. Ljudje v HoReCa okolju se odzovejo na energijo, ne na skripto.', metric: '20+', metricLabel: 'DCC / izmena' },
        { title: 'Wibe = Stabilnost', text: 'Naši sodelavci ostajajo z nami, ker se pri nas počutijo slišane in cenjene. Močna ekipna kultura pomeni, da projekt INFORMERS vodimo z isto ekipo od prvega do zadnjega dne.', metric: '↑', metricLabel: 'Lojalnost ekipe' },
        { title: 'Reševanje izzivov na terenu', text: 'Ko so odnosi v ekipi močni, se težave na terenu rešujejo s proaktivnim pristopom, ne z iskanjem krivcev. Vsak dan projekta je ekipa motivirana in usmerjena v rezultat.', metric: '0', metricLabel: 'Tolerance za izgovore' },
      ],
    },

    reward: {
      label:       'The Wibe Reward Model',
      headline:    'Strateško razmerje',
      headlineAccent: '80/20.',
      sub:         'Varnost blagovne znamke skozi fer plačilo.',
      scrollHint:  'Scrollaj za animacijo ↓',
      baseLabel:   'The Base',
      baseFixed:   '80 % Fiksno',
      baseTagline: 'Stabilnost, zrelost, nizka fluktuacija.',
      baseNote:    'Zagotavlja zrele komunikatorje (21+)',
      driveLabel:  'The Drive',
      driveFixed:  'Performance Bonus',
      driveTagline:'Motivacija brez agresivnosti.',
      driveNote:   'Preprečuje agresivno vedenje na terenu',
      footer:      'Brez vsiljive prodaje.',
      footerAccent:'100 % profesionalizem.',
    },

    logistics: {
      label:        'Logistično središče',
      address:      'Letališka 34',
      addressSub:   'Ljubljana · Nekaj minut od sedeža PMI',
      feat1Title:   '200 m² operativne moči',
      feat1Body:    'Skladiščenje, distribucija vzorcev in upravljanje opreme na enem mestu.',
      feat2Title:   'Maksimalna agilnost',
      feat2Body:    'Zaradi neposredne bližine zagotavljamo odzivni čas, ki ga drugi ne morejo.',
      feat3Title:   'Wibe Academy',
      feat3Body:    'Dostop do vrhunskih prostorov v sodelovanju z Agencijo 101. Dvorana za 40 oseb, sejna soba za 15 oseb.',
      kpi1:  'Skladiščni prostor',
      kpi2:  'Kapaciteta dvorane',
      kpi3:  'Do sedeža PMI',
      diagramLabel: 'Operativni center',
      warehouse: 'SKLADIŠČE',
      distribution: 'DISTRIBUCIJA',
    },

    selection: {
      label:    'Science of Selection',
      headline: 'Znanost za izborom',
      body:     'Vsak informator gre skozi večstopenjski izbirni postopek. Kombiniramo psihološko profiliranje in Brand Fit ocenjevanje za zagotavljanje vrhunske kakovosti.',
      methodLabel: 'Metoda',
      metrics: [
        { label: 'EQ (Emocionalni kvocient)', description: 'EQ-i 2.0 & Big Five psihološko profiliranje zagotavlja odpornost in empatijo na terenu.', method: 'Standardizirano EQ-i 2.0 testiranje + vedenjski intervju' },
        { label: 'Tech Affinity', description: 'Ocenjujemo digitalno pismenost, hitrost učenja novih orodij in sposobnost uporabe Wibe Intel platforme.', method: 'Praktični test z Wibe Intel + digitalna simulacija' },
        { label: 'Agility', description: 'Merimo sposobnost prilagajanja, hitrost odločanja in uspešnost v nepredvidljivih situacijah.', method: 'Situacijski testi + AI video analiza odzivov' },
        { label: 'Brand Fit Index', description: 'Vsak informator je izbran tako, da 100% zrcali ugled in vrednote znamke Philip Morris.', method: 'Brand alignment assessment + AI neverbalna analiza' },
      ],
    },

    compliance: {
      badge:       'Compliance & RSP',
      headline:    'Zaveza k',
      headlineAccent: 'odgovornemu poslovanju.',
      sub:         'Naš operativni model je v celoti usklajen z RSP standardi PMI.',
      staffingBadge: 'PMI Compliant Staffing',
      staffingTitle: 'The Right People.',
      staffingTitleAccent: 'Vsakič.',
      staffingBody: 'Izključno profili 21+, vešči komunikacije v HoReCa okolju, v skladu s standardi blagovne znamke PMI.',
      footer:      'Brand-aligned · Ethics-first · Zero tolerance policy',
      rspItems: [
        { title: 'Responsible Sourcing Principles', text: 'Eksplicitna potrditev vseh RSP načel PMI. Operativni model vzpostavljen v skladu z mednarodnimi standardi.' },
        { title: 'Delovni pogoji & počitek', text: 'Max 48h/teden z zagotovljenimi odmorki za vsakega člana ekipe. Nič kompromisov.' },
        { title: 'Visoka stabilnost ekipe', text: 'Sodelavci ostajajo z nami. Za PMI to pomeni stabilno ekipo brez nepotrebnih zamenjav.' },
      ],
      staffingPoints: [
        'Izključno profili 21+ let (videz 25+)',
        'Preverjena komunikacijska kompetentnost v HoReCa okolju',
        'Ustreznost estetskim in komunikacijskim standardom blagovne znamke',
        'Psihološko profiliranje pred aktivacijo (EQ-i 2.0)',
        'Brez kazenskih evidenc – popolna kadrovska čistoča',
      ],
    },

    intel: {
      label:       'Wibe Intel Platform',
      headline1:   'The Brain.',
      headline2:   'Operativna',
      headlineAccent: 'inteligenca.',
      sub:         'Digitalna hrbtenica projekta INFORMERS — real-time sledenje DCC, optimizacija poti in analitika v enem vmesniku.',
      feats: [
        { title: 'HoReCa Master DB',      desc: 'Integrirana baza 1.500+ primernih objektov z analitiko publike in zgodovino obiskov.' },
        { title: 'AI Route Optimizer',    desc: 'Optimizacija 15 obiskov na dan na podlagi prioritet in lokacij ekip.' },
        { title: 'Real-Time Dashboard',   desc: 'PMI vodstvo vidi DCC rezultate v trenutku vnosa — brez zamud.' },
        { title: 'Knowledge Sharing Hub', desc: 'Takojšen prenos dobrih praks in RRP gradiv med terenskimi ekipami.' },
        { title: 'AI Debrief asistent',   desc: 'Glasovni post-shift debrief z AI — pogovor se samodejno pretvori v strukturirane podatke.' },
      ],
      kpi1:  'Obiskov/dan',
      kpi2:  'DCC cilj/izmeno',
      kpi3:  'Lokacij v DB',
      dccLabel: 'DCC Cilj / izmena',
      dccSub:   'kontaktov / informator',
    },

    aiDebrief: {
      label:         'AI Debrief · The Brain',
      headline1:     'Glasovni',
      headline2:     'terenski',
      headlineAccent:'asistent.',
      sub:           'Po vsaki izmeni AI asistent vodi naravni glasovni debrief — opažanja s terena se samodejno pretvorijo v strukturirane podatke, posodobitve poti in poročila za PMI.',
      feats: [
        { title: 'Naravni glasovni debrief',     desc: 'Informatorji govorijo naravno po izmeni. AI pretvori pogovor v strukturirane DCC podatke v sekundah.' },
        { title: 'Samodejno zaznavanje vpogledov', desc: 'AI zazna ključne signale — ugovore, motnje, dobre prakse — in jih označi v realnem času.' },
        { title: 'Poročanje skladno z RSP',       desc: 'Vsak debrief se samodejno preveri glede na načela odgovorne nabave PMI (RSP).' },
        { title: 'Samodejna optimizacija poti',   desc: 'Vpogledi iz debriefov neposredno posodobijo AI Route Optimizer za naslednjo izmeno.' },
      ],
      kpi1: 'Max čas debriefa',
      kpi2: 'Točnost podatkov',
      kpi3: 'Razpoložljivost',
    },

    marketing: {
      label:      'Marketing UX & Reputation',
      headline:   'Marketing je naš DNK',
      bodyBase:   'Razumemo, da informator ni le podajalec informacij, temveč',
      bodyAccent: 'skrbnik ugleda',
      bodyEnd:    '(Brand Guardian). Vsak stik s stranko je priložnost za gradnjo zaupanja.',
      diagramSub: 'Večstopenjski Brand Guardian model',
      diagramLabels: { quality: 'KAKOVOST', ethics: 'ETIKA' },
      pillars: [
        { title: 'RSP Compliance',           desc: 'Stroga etična načela in načela odgovorne nabave so vgrajena v vsak proces.' },
        { title: 'Brand Guardian pristop',   desc: 'Vsak informator deluje kot ambasador znamke z najvišjo stopnjo profesionalnosti.' },
        { title: 'Kakovost interakcij',      desc: 'Kvaliteta pogovora je enako pomembna kot kvantiteta obiskov.' },
        { title: 'Kontinuirano usposabljanje', desc: 'Redni treningi in coaching zagotavljajo dosleden Brand Experience.' },
      ],
    },

    strategic: {
      badge:     'Strategic Commitment',
      headline1: 'Več kot storitev.',
      headlineAccent: 'Vaše strateško partnerstvo.',
      body:      'V Wibe Solutions smo se odločili za specializacijo namesto masovnosti. Za nas niste le ena od mnogih strank v portfelju – ste naš osrednji strateški partner, za katerega smo prilagodili celotno operativno infrastrukturo. Od logističnega vozlišča na Letališki do zadnjega detajla na uniformah informatorjev; vse je podrejeno brezhibni izvedbi vaše vizije INFORMERS 2026.',
      signature: 'Wibe Solutions d.o.o. \u2013 Va\u0161a podalj\u0161ana roka na terenu.',
    },

    closing: {
      headline1:      'V letu 2026 na terenu ne boste imeli le ekipe.',
      headlineAccent: 'Imeli boste inteligenten sistem.',
      sub:     'Ki se uči in prilagaja. Mi smo Wibe Solutions. Vaša operativna prednost se začne tukaj.',
      btnPrimary:   'Več o nas',
      btnSecondary: 'Nazaj na vrh',
      kpis: [
        { value: '15+',    label: 'Let izkušenj' },
        { value: '1.500+', label: 'HoReCa lokacij' },
        { value: '21+',    label: 'Starostna skupina' },
        { value: '2.800+', label: 'Preverjenih talentov' },
      ],
    },

    footer: {
      company: 'Wibe Solutions d.o.o.',
      tagline: 'Operativna odličnost za vašo blagovno znamko.',
      contactTitle: 'Kontakt',
      address1: 'Letališka cesta 34',
      address2: '1000 Ljubljana, Slovenija',
      copyright: '© 2026 Wibe Solutions d.o.o. Vse pravice pridržane.',
      compliance: 'RSP Skladnost · Odgovorno poslovanje',
    },

    sectionLabels: ['INFORMERS','Ekipa','Reference','Projekti','O nas','The Wibe','SPOC','Struktura','80/20','Logistika','Selekcija','Compliance','Platforma','AI Debrief','Marketing','Trajnost','Vrednote','Zakaj Wibe','Zaveza','Zaključek'],
  },

  // ─── ENGLISH ────────────────────────────────────────────────────────────────
  en: {
    nav: { scrollHint: 'Discover more' },

    hero: {
      badge:    'Project INFORMERS',
      title1:   'Strategic dominance',
      title2:   'in the field.',
      subtitle: 'Your operational backbone for the \u201cSmoke-Free Future\u201d vision. Flawless execution of the INFORMERS program with a focus on compliance, ethics and measurable results.',
    },

    legacy: {
      label:      'The Powerhouse',
      headline:   'Operational excellence through the power of relationships.',
      body:       'At Wibe Solutions we believe that top results are driven not only by processes, but by an authentic \u201evibe\u201c \u2013 a culture of trust and energy that transforms field activation into an exceptional consumer experience.',
      feat1Title: 'Years of experience',
      feat1Body:  'Extensive experience in the FMCG sector and complex promotions. Our track record speaks for itself.',
      feat2Title: 'Unmatched talent pool',
      feat2Body:  'Access to a network of 2,800+ vetted communicators with HoReCa experience. We don\u2019t search for new people; we activate talents that have grown with us.',
      feat3Title: 'National coverage',
      feat3Body:  'All of Slovenia covered. From Koper to Murska Sobota, from Nova Gorica to Novo Mesto.',
      kpi1:  'HoReCa locations',
      kpi2:  'Vetted talents',
      kpi3:  'Above-average stability',
      kpi4:  'Age group',
      regionWest: 'CENTER & WEST',
      regionEast: 'EAST',
    },

    team: {
      label:    'Project Team',
      headline: 'People behind the',
      headlineAccent: 'results.',
      sub:      'An experienced team standing behind every field success.',
      members: [
        {
          name: 'Žiga Goltes', title: 'CEO',
          bio: 'With over 15 years in agency management and complex BTL projects, he builds not just processes but relationships. As a co-creator of innovations at Agency 101 he paved the way for modern promotional approaches. Today at Wibe Solutions he combines new technologies with authentic human communication.',
        },
        {
          name: 'Andrej Hrastar', title: 'Project Manager',
          bio: 'Strategic leader with over 20 years of experience in the automotive industry and sales management. Built his career leading key projects for Porsche and VW, specialising in e-mobility rollouts and innovative go-to-market strategies. He believes that people and strong team synergy are key to business success.',
        },
        {
          name: 'Karin Kočar', title: 'Recruitment & Back Office',
          bio: 'With over 15 years managing hostess and promotional services, she is one of Slovenia\u2019s leading field-staffing specialists. Her role in the INFORMERS project is crucial: ensuring top-tier selection of informers (21+) who meet Philip Morris\u2019s strict standards.',
        },
        {
          name: 'Alen Radi', title: 'Operations',
          bio: 'In the world of field activations, a synonym for operational sharpness and reliability. As the management\u2019s right hand he takes responsibility for the technical and logistical stability of projects, standing out as one of the most promising individuals of his generation.',
        },
      ],
      refsLabel: 'References',
      refs: [
        'Agencija 101 d.o.o.',
        'Pivoarna Laško Union d.o.o.',
        'Coca Cola HBC Slovenija d.o.o.',
        'Zavarovalnica Vita, d.d.',
        'EUROSPIN EKO, d.o.o.',
        'Komisija za preprečevanje korupcije',
        'DEKRA ZAPOSLITEV d.o.o. (JTI)',
      ],
    },

    wibeFactor: {
      label:          'The Wibe Factor',
      headline:       'Why energy',
      headlineAccent: 'drives numbers.',
      quote:          'Wibe is not just our name, it\u2019s our way of working. Strong relationships within the team are the invisible engine that drives visible results in the field.',
      quoteAuthor:    'Žiga Goltes, CEO',
      cards: [
        { title: 'Genuine contact, not just statistics', text: 'An informer with great energy not only hits 20 contacts per shift, but leaves a positive impression of the IQOS/RRP brand. People in HoReCa respond to energy, not a script.', metric: '20+', metricLabel: 'DCC / shift' },
        { title: 'Wibe = Stability', text: 'Our team members stay because they feel heard and valued. A strong team culture means we run the INFORMERS project with the same team from day one to the last day \u2014 no unnecessary turnover.', metric: '\u2191', metricLabel: 'Team loyalty' },
        { title: 'Solving field challenges', text: 'When team relationships are strong, field problems are solved proactively, not by blame-shifting. Every project day the team is motivated and result-focused.', metric: '0', metricLabel: 'Tolerance for excuses' },
      ],
    },

    reward: {
      label:       'The Wibe Reward Model',
      headline:    'Strategic ratio',
      headlineAccent: '80/20.',
      sub:         'Brand safety through fair pay.',
      scrollHint:  'Scroll to animate \u2193',
      baseLabel:   'The Base',
      baseFixed:   '80% Fixed',
      baseTagline: 'Stability, maturity, low turnover.',
      baseNote:    'Ensures mature communicators (21+)',
      driveLabel:  'The Drive',
      driveFixed:  'Performance Bonus',
      driveTagline:'Motivation without aggression.',
      driveNote:   'Prevents aggressive field behaviour',
      footer:      'No pushy selling.',
      footerAccent:'100% professionalism.',
    },

    logistics: {
      label:        'Logistics Hub',
      address:      'Letališka 34',
      addressSub:   'Ljubljana · Minutes from PMI headquarters',
      feat1Title:   '200 m² of operational power',
      feat1Body:    'Storage, sample distribution and equipment management in one place.',
      feat2Title:   'Maximum agility',
      feat2Body:    'Proximity to PMI HQ ensures response times that others simply cannot match.',
      feat3Title:   'Wibe Academy',
      feat3Body:    'Access to premium facilities in partnership with Agency 101. Hall for 40 people, boardroom for 15.',
      kpi1:  'Storage area',
      kpi2:  'Hall capacity',
      kpi3:  'To PMI HQ',
      diagramLabel: 'Operations centre',
      warehouse: 'WAREHOUSE',
      distribution: 'DISTRIBUTION',
    },

    selection: {
      label:    'Science of Selection',
      headline: 'The science behind selection',
      body:     'Every informer goes through a multi-stage selection process. We combine psychological profiling and Brand Fit assessment to guarantee top quality.',
      methodLabel: 'Method',
      metrics: [
        { label: 'EQ (Emotional Quotient)', description: 'EQ-i 2.0 & Big Five psychological profiling ensures resilience and empathy in the field.', method: 'Standardised EQ-i 2.0 testing + behavioural interview' },
        { label: 'Tech Affinity', description: 'We assess digital literacy, speed of learning new tools and ability to use the Wibe Intel platform.', method: 'Practical Wibe Intel test + digital simulation' },
        { label: 'Agility', description: 'We measure adaptability, decision speed and performance in unpredictable situations.', method: 'Situational tests + AI video response analysis' },
        { label: 'Brand Fit Index', description: 'Every informer is chosen to 100% mirror the reputation and values of the Philip Morris brand.', method: 'Brand alignment assessment + AI non-verbal analysis' },
      ],
    },

    compliance: {
      badge:       'Compliance & RSP',
      headline:    'Committed to',
      headlineAccent: 'responsible business.',
      sub:         'Our operational model is fully aligned with PMI\u2019s RSP standards.',
      staffingBadge: 'PMI Compliant Staffing',
      staffingTitle: 'The Right People.',
      staffingTitleAccent: 'Every time.',
      staffingBody: 'Exclusively 21+ profiles, skilled in HoReCa communication, aligned with PMI brand standards.',
      footer:      'Brand-aligned \u00b7 Ethics-first \u00b7 Zero tolerance policy',
      rspItems: [
        { title: 'Responsible Sourcing Principles', text: 'Explicit confirmation of all PMI RSP principles. Operational model established in accordance with international standards.' },
        { title: 'Working conditions & rest', text: 'Max 48h/week with guaranteed breaks for every team member. No compromises.' },
        { title: 'High team stability', text: 'Team members stay with us. For PMI this means a stable team without unnecessary replacements.' },
      ],
      staffingPoints: [
        'Exclusively 21+ profiles (appearance 25+)',
        'Verified communication skills in a HoReCa environment',
        'Alignment with brand aesthetic and communication standards',
        'Psychological profiling before activation (EQ-i 2.0)',
        'No criminal record \u2013 full personnel integrity',
      ],
    },

    intel: {
      label:       'Wibe Intel Platform',
      headline1:   'The Brain.',
      headline2:   'Operational',
      headlineAccent: 'intelligence.',
      sub:         'The digital backbone of the INFORMERS project \u2014 real-time DCC tracking, route optimisation and analytics in one interface.',
      feats: [
        { title: 'HoReCa Master DB',      desc: 'Integrated database of 1,500+ eligible venues with audience analytics and visit history.' },
        { title: 'AI Route Optimizer',    desc: 'Optimise 15 visits per day based on priorities and team locations.' },
        { title: 'Real-Time Dashboard',   desc: 'PMI management sees DCC results the moment they are entered \u2014 no delays.' },
        { title: 'Knowledge Sharing Hub', desc: 'Instant transfer of best practices and RRP materials between field teams.' },
        { title: 'AI Debrief Assistant',  desc: 'Voice-driven post-shift debrief powered by AI — converts conversation into structured data instantly.' },
      ],
      kpi1:  'Visits/day',
      kpi2:  'DCC target/shift',
      kpi3:  'Venues in DB',
      dccLabel: 'DCC Target / shift',
      dccSub:   'contacts / informer',
    },

    aiDebrief: {
      label:         'AI Debrief · The Brain',
      headline1:     'Voice-driven',
      headline2:     'field',
      headlineAccent:'intelligence.',
      sub:           'After each shift, the AI assistant conducts a natural voice debrief — converting field observations into structured data, route updates and PMI-ready reports automatically.',
      feats: [
        { title: 'Natural Voice Debrief',      desc: 'Informers speak naturally after their shift. AI converts conversation into structured DCC data in seconds.' },
        { title: 'Automatic Insight Detection',desc: 'AI identifies key signals — objections, disruptions, best practices — and tags them in real time.' },
        { title: 'RSP-Compliant Reporting',    desc: 'Every debrief entry is automatically verified against PMI Responsible Sourcing Principles.' },
        { title: 'Route Auto-Optimisation',    desc: 'Insights from debriefs directly update the AI Route Optimizer for the next shift — no manual input needed.' },
      ],
      kpi1: 'Max debrief time',
      kpi2: 'Data accuracy',
      kpi3: 'Availability',
    },

    marketing: {
      label:      'Marketing UX & Reputation',
      headline:   'Marketing is our DNA',
      bodyBase:   'We understand that an informer is not just a provider of information, but a',
      bodyAccent: 'brand guardian',
      bodyEnd:    '(Brand Guardian). Every interaction with a customer is an opportunity to build trust.',
      diagramSub: 'Multi-tier Brand Guardian model',
      diagramLabels: { quality: 'QUALITY', ethics: 'ETHICS' },
      pillars: [
        { title: 'RSP Compliance',           desc: 'Strict ethical principles and responsible sourcing principles are embedded in every process.' },
        { title: 'Brand Guardian approach',  desc: 'Every informer acts as a brand ambassador with the highest level of professionalism.' },
        { title: 'Quality of interactions',  desc: 'Quality of conversation is just as important as the quantity of visits.' },
        { title: 'Continuous training',      desc: 'Regular training and coaching ensure a consistent Brand Experience.' },
      ],
    },

    strategic: {
      badge:     'Strategic Commitment',
      headline1: 'More than a service.',
      headlineAccent: 'Your strategic partnership.',
      body:      'At Wibe Solutions we have chosen specialisation over volume. You are not just one of many clients in our portfolio \u2013 you are our central strategic partner, for whom we have tailored our entire operational infrastructure. From the logistics hub on Letali\u0161ka to the last detail on informer uniforms; everything is dedicated to flawless execution of your INFORMERS 2026 vision.',
      signature: 'Wibe Solutions d.o.o. \u2013 Your extended arm in the field.',
    },

    closing: {
      headline1:      'In 2026 you won\u2019t just have a field team.',
      headlineAccent: 'You\u2019ll have an intelligent system.',
      sub:     'That learns and adapts. We are Wibe Solutions. Your operational advantage starts here.',
      btnPrimary:   'Learn more',
      btnSecondary: 'Back to top',
      kpis: [
        { value: '15+',    label: 'Years of experience' },
        { value: '1,500+', label: 'HoReCa locations' },
        { value: '21+',    label: 'Age group' },
        { value: '2,800+', label: 'Vetted talents' },
      ],
    },

    footer: {
      company: 'Wibe Solutions d.o.o.',
      tagline: 'Operational excellence for your brand.',
      contactTitle: 'Contact',
      address1: 'Letališka cesta 34',
      address2: '1000 Ljubljana, Slovenia',
      copyright: '© 2026 Wibe Solutions d.o.o. All rights reserved.',
      compliance: 'RSP Compliance · Responsible Business',
    },

    sectionLabels: ['INFORMERS','Team','References','Projects','About','The Wibe','SPOC','Structure','80/20','Logistics','Selection','Compliance','Platform','AI Debrief','Marketing','Sustainability','Values','Why Wibe','Commitment','Closing'],
  },
};

export const t = (lang) => translations[lang] || translations.sl;
